import React, { useState, useEffect } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Label,
  Row,
  Col,
  Form,
} from "reactstrap";
import Flatpickr from "react-flatpickr";

const EditAdminStatusModal = ({ isOpen, toggle, user, onSubmit }) => {
  const [formData, setFormData] = useState({
    startDate: "",
    expiryDate: "",
  });

  // Load user data when modal opens
  useEffect(() => {
    if (user) {
      setFormData({
        startDate: user.startDate || "",
        expiryDate: user.expiryDate || "",
      });
    }
  }, [user]);

  // Handle form submit
  const handleSubmit = () => {
    const id = user.id;
    const updatedUser = {
      ...formData,
    };
    onSubmit(id, updatedUser); // send updated object to parent
    toggle(); // close modal
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered>
      <ModalHeader toggle={toggle} style={{ background: "#E7F3FF" }}>
        Edit Dates
      </ModalHeader>

      <ModalBody>
        <Form>
          <Row>
            {/* START DATE */}
            <Col md={12} className="mb-3">
              <Label className="form-label">Start Date</Label>
              {/* <Flatpickr
                value={formData.startDate}
                options={{ dateFormat: "d-m-Y" }}
                className="form-control"
                onChange={(date) =>
                  setFormData({
                    ...formData,
                    startDate: date[0]
                      ? date[0].toLocaleDateString("en-GB")
                      : "",
                  })
                }
              /> */}
              <Flatpickr
                value={formData.startDate}
                options={{ dateFormat: "d-m-Y" }}
                className="form-control"
                onChange={(date) =>
                  setFormData({
                    ...formData,
                    startDate: date[0]
                      ? date[0].toLocaleDateString("en-GB").replaceAll("/", "-")
                      : "",
                  })
                }
              />
            </Col>

            {/* EXPIRY DATE */}
            <Col md={12} className="mb-3">
              <Label className="form-label">Expiry Date</Label>
              <Flatpickr
                value={formData.expiryDate}
                options={{ dateFormat: "d-m-Y" }}
                className="form-control"
                onChange={(date) =>
                  setFormData({
                    ...formData,
                    expiryDate: date[0]
                      ? date[0].toLocaleDateString("en-GB").replaceAll("/", "-")
                      : "",
                  })
                }
              />
            </Col>
          </Row>
        </Form>
      </ModalBody>

      <ModalFooter>
        <Button color="secondary" onClick={toggle}>
          Cancel
        </Button>
        <Button color="primary" onClick={handleSubmit}>
          Save Changes
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default EditAdminStatusModal;
